import { _defaults } from './defaults.ts';
export class _Hooks {
    constructor(options) {
        this.options = options || _defaults;
    }
    /**
     * Process markdown before marked
     */
    preprocess(markdown) {
        return markdown;
    }
    /**
     * Process HTML after marked is finished
     */
    postprocess(html) {
        return html;
    }
}
_Hooks.passThroughHooks = new Set([
    'preprocess',
    'postprocess'
]);
